<template>
	<div id="app">
		<router-view />
		<!-- <div class="loading" v-if="$store.state.is_loading||!$store.state.init_loading"></div> -->
		<!--背景音乐引入示例-->
		<!-- <Music src="https://jm-svg.oss-cn-beijing.aliyuncs.com/f79625464f0245afa5084cdae9a324da.mp3"></Music> -->
		<div class="loading-gps" v-if="$store.state.is_get_gps_loading">获取地理位置中...</div>
	</div>
</template>

<script>
	import Music from '@/components/music'

	export default {
		components: {
			Music
		},
		provide() {
			//提供reload方法
			return {
				reload: this.reload
			};
		},
		data() {
			return {
				isRouterAlive: true // isRouterAlive控制显示
			};
		},
		methods: {
			preloadAllImages() {
				// 1. 使用 require.context 匹配 assets 目录下的所有图片
				const imageContext = require.context('../assets', true, /\.(png|jpe?g|gif|svg|mp4)$/);

				// 2. 获取所有图片路径
				const imagePaths = imageContext.keys();

				// 3. 预加载每张图片
				imagePaths.forEach((path, index) => {
					const img = new Image();
					img.src = imageContext(path);
					// console.log('图片记载完毕');
				});
			},
			// 刷新方法
			reload: function() {
				this.isRouterAlive = false;
				// 该方法会在dom更新后执行
				this.$nextTick(function() {
					this.isRouterAlive = true;
				});
			},
			// 滚动条
			changeScrollTop() {
				$("#app").on("blur", "input,textarea", function() {
					$(window).scrollTop(0, 0);
				});
			},
			setPlaceholder() {
				//placeholder 安卓处理
				if (jm.terminal.android) {
					$("#app").on("focus", "input", function() {
						this.placeholder = "";
					});
				}
			}
		},
		mounted() {
			this.changeScrollTop();
			this.preloadAllImages()
		},
		created() {

		}
	};
</script>


// WEBPACK FOOTER //
// src/view/main.vue